// pages/analytics.js — Analytics page.
//
// Owns the `data-page="analytics"` section. Cloud-only: queries the
// coordinator's roll-up endpoint /v1/teams/analytics for top
// contested files, top agents, daily + hourly trends. Daemon mode
// shows a "team analytics is on the coordinator" placeholder.
//
// 402 / upgrade_required → show the solo/startup upgrade gate.
// Other errors → render with "--" values in the totals chips.
//
// As of Phase J7-e the actual render + sub-renderers + window
// picker / upgrade button event wiring all live in src/analytics.js.
// This page module owns the mount lifecycle (dashboard:tick
// + MutationObserver) and dispatches to renderAnalyticsPage when
// the user is on the page.
import { state } from "../state.js";
import { renderAnalyticsPage } from "../analytics.js";

// ---- mount ----

let started = false;
let tickHandler = null;

function start() {
  if (started) return;
  started = true;
  // Initial render — cloud mode has no daemon-driven tick loop, so
  // without this the page sits blank until manual nav. See
  // policy.js / worktrees.js for the same fix.
  renderAnalyticsPage();
  tickHandler = () => {
    if (state.activePage === "analytics") renderAnalyticsPage();
  };
  document.addEventListener("dashboard:tick", tickHandler);
}

function stop() {
  if (!started) return;
  started = false;
  if (tickHandler) {
    document.removeEventListener("dashboard:tick", tickHandler);
    tickHandler = null;
  }
}

function bindLifecycle() {
  const section = document.querySelector('section.page[data-page="analytics"]');
  if (!section) return;
  if (section.classList.contains("active")) start();
  const obs = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.attributeName !== "class") return;
      if (section.classList.contains("active")) start();
      else stop();
    });
  });
  obs.observe(section, { attributes: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindLifecycle);
} else {
  bindLifecycle();
}
